export const mocked_data = [
  {
    user_id: 25701,
    reason: 'New High Risk Med',
    description: 'Anticoagulant therapy, high bleeding risk.',
    priority: 'High',
    suggested_action:
      'Patient on warfarin, INR last 4.2. Reduce dose from 7.5 mg to 5 mg daily, repeat INR in 3 days. Stop concurrent ibuprofen. Add omeprazole 20 mg daily for GI protection. Educate on bleeding signs.'
  },
  {
    user_id: 29863,
    reason: 'Recent Hospitalization',
    description: 'Emergency visit for chest pain, ruled out MI. (2 days ago)',
    priority: 'High',
    suggested_action:
      'Discharge meds: aspirin 81 mg daily, atorvastatin 40 mg qhs. Add metoprolol succinate 25 mg daily for secondary prevention. Schedule stress test in 2 weeks and cardiology follow-up.'
  },
  {
    user_id: 38291,
    reason: 'Recent Hospitalization',
    description: 'Hospitalized for pneumonia. (4 days ago)',
    priority: 'High',
    suggested_action:
      'Currently on levofloxacin 750 mg daily \u00d7 7 days (day 4/7). Verify adherence and hydration. Add pneumococcal conjugate vaccine (PCV20) at follow-up. Reassess oxygen saturation daily for 1 week.'
  },
  {
    user_id: 18943,
    reason: 'New High Risk Med',
    description: 'Surgery with ongoing opioid prescription. (3 days ago)',
    priority: 'High',
    suggested_action:
      'Discharged on oxycodone 5 mg q6h PRN (20 tabs). Initiate taper: q8h max \u00d7 2 days, then q12h max \u00d7 2 days, then stop. Add acetaminophen 1 g q8h scheduled. Dispense naloxone nasal spray to caregiver.'
  },
  {
    user_id: 49321,
    reason: 'Recent Hospitalization',
    description: 'Asthma exacerbation requiring ER visit. (5 days ago)',
    priority: 'High',
    suggested_action:
      'Patient discharged on albuterol only. Start budesonide-formoterol 160/4.5 \u00b5g, 2 puffs bid + 1 puff PRN (SMART protocol). Provide spacer and inhaler technique training. Schedule pulm follow-up in 1 month.'
  },
  {
    user_id: 34902,
    reason: 'New High Risk Med',
    description: 'Initiated insulin therapy. (6 days ago)',
    priority: 'High',
    suggested_action:
      'Start basal insulin glargine 10 U qhs. Educate on titration: +2 U every 3 days until fasting glucose 80\u2013130 mg/dL. Provide pen needles, glucometer, and hypoglycemia action plan (15/15 rule).'
  },
  {
    user_id: 44215,
    reason: 'Recent Hospitalization',
    description: 'Post-stroke rehabilitation started. (6 days ago)',
    priority: 'High',
    suggested_action:
      'Continue aspirin 81 mg daily, switch simvastatin 20 mg to atorvastatin 80 mg nightly. Add lisinopril 10 mg daily (BP 148/92). Refer for swallow evaluation. Enroll in adherence packaging program.'
  },
  {
    user_id: 33082,
    reason: 'Recent Hospitalization',
    description: 'Transitioned to dialysis. (1 days ago)',
    priority: 'High',
    suggested_action:
      'Stop metformin and lisinopril. Adjust gabapentin to 300 mg post-dialysis only. Start renal vitamin (Nephrocaps). Verify epoetin use at dialysis center.'
  },
  {
    user_id: 14561,
    reason: 'Recent Hospitalization',
    description: 'Hospitalization for heart failure. (5 days ago)',
    priority: 'High',
    suggested_action:
      'Discharge meds incomplete. Start sacubitril/valsartan 24/26 mg bid, carvedilol 3.125 mg bid, spironolactone 25 mg daily. Daily weight log and sodium <2 g/day. Pharmacy phone follow-up in 3 days.'
  },
  {
    user_id: 40128,
    reason: 'New Diagnosis',
    description: 'New diagnosis of gestational diabetes. (6 days ago)',
    priority: 'High',
    suggested_action:
      'Provide SMBG kit (fasting + 1h postprandial). If fasting >95 mg/dL, start insulin NPH 0.2 U/kg qhs. Dietitian referral for carb counting. Weekly OB/pharmacy joint review.'
  },
  {
    user_id: 48972,
    reason: 'New Diagnosis',
    description: 'Newly diagnosed with stage II hypertension.',
    priority: 'Medium',
    suggested_action:
      'Initiate amlodipine 5 mg daily. Educate on DASH diet and home BP monitoring twice daily \u00d7 2 weeks. If >140/90 persists, add losartan 50 mg daily.'
  },
  {
    user_id: 23489,
    reason: 'Disease State Management',
    description: 'Evidence of poor diabetes control (HbA1c > 9%).',
    priority: 'Medium',
    suggested_action:
      'Add semaglutide 0.25 mg weekly in addition to metformin 1000 mg bid. Recheck A1c in 3 months. Counsel on GI side effects and weight monitoring.'
  },
  {
    user_id: 5211,
    reason: 'Disease State Management',
    description: 'Chronic kidney disease stage 3, needs close monitoring.',
    priority: 'Medium',
    suggested_action:
      'Continue losartan 50 mg daily. Add dapagliflozin 10 mg daily (eGFR 45). Stop NSAIDs. Order BMP q3 months. Educate on hydration and nephrology follow-up.'
  },
  {
    user_id: 35412,
    reason: 'Therapy Optimization',
    description: 'Identified drug duplication in diabetes therapy.',
    priority: 'Medium',
    suggested_action:
      'Stop sitagliptin 100 mg daily (patient also on alogliptin). Keep metformin and empagliflozin. Simplify regimen to reduce pill burden.'
  },
  {
    user_id: 5007,
    reason: 'Therapy Optimization',
    description: 'COPD patient on suboptimal inhaled therapy.',
    priority: 'Medium',
    suggested_action:
      'Switch to tiotropium/olodaterol Respimat 2 puffs daily. Continue albuterol PRN. Provide inhaler teaching session. Vaccinate for influenza.'
  },
  {
    user_id: 18473,
    reason: 'Disease State Management',
    description: 'Severe depression, non-adherent to meds.',
    priority: 'Medium',
    suggested_action:
      'Switch to once-daily escitalopram 10 mg (simpler than paroxetine BID). Use blister packs. Weekly phone follow-up \u00d7 1 month. Suicide risk screening at every contact.'
  },
  {
    user_id: 37459,
    reason: 'Disease State Management',
    description: 'History of seizures, recent breakthrough episode.',
    priority: 'Medium',
    suggested_action:
      'Patient on levetiracetam 500 mg bid. Increase to 750 mg bid. Order serum level at 1 week. Stress adherence counseling. Notify neurology for expedited visit.'
  },
  {
    user_id: 28814,
    reason: 'Disease State Management',
    description: 'Multiple comorbidities requiring medication review.',
    priority: 'Medium',
    suggested_action:
      'Deprescribe duplicate PPIs (omeprazole + pantoprazole \u2192 keep omeprazole only). Convert TID metoprolol tartrate to succinate once daily. Enroll in med sync program.'
  },
  {
    user_id: 42369,
    reason: 'Therapy Optimization',
    description: 'Identified risky drug-drug interaction.',
    priority: 'Medium',
    suggested_action:
      'Current meds: simvastatin 40 mg + clarithromycin. Stop simvastatin immediately. Resume atorvastatin 20 mg after antibiotic course. Document DDI resolution.'
  },
  {
    user_id: 23412,
    reason: 'New Diagnosis',
    description:
      'Significant weight loss linked to new diagnosis. (2 days ago)',
    priority: 'Medium',
    suggested_action:
      'Weight loss 12% in 3 months. Order TSH, HbA1c, chest X-ray. Add Ensure Plus 1 can bid. PCP follow-up in 7 days.'
  },
  {
    user_id: 17654,
    reason: 'Cost Savings',
    description: 'On specialty biologic with potential generic alternative.',
    priority: 'Low',
    suggested_action:
      'Current: Humira 40 mg q2w. Switch to Amjevita 40 mg q2w (biosimilar). Submit prior auth for formulary coverage.'
  },
  {
    user_id: 42109,
    reason: 'Cost Savings',
    description: 'Uses high-cost GLP-1 therapy; cheaper alternatives exist.',
    priority: 'Low',
    suggested_action:
      'Current: Ozempic 1 mg weekly. Switch to Victoza 1.8 mg daily (covered). Educate on injection technique and titration schedule.'
  },
  {
    user_id: 46107,
    reason: 'Cost Savings',
    description: 'Taking multiple branded inhalers, candidate for interchange.',
    priority: 'Low',
    suggested_action:
      'Current: Advair + Spiriva. Switch to Trelegy Ellipta 100/62.5/25 \u00b5g 1 puff daily (triple therapy). Lower copay, improved adherence.'
  },
  {
    user_id: 13876,
    reason: 'Cost Savings',
    description: 'High spend on brand-name statin; generic available.',
    priority: 'Low',
    suggested_action:
      'Current: Crestor 20 mg daily. Switch to rosuvastatin generic 20 mg daily. Update med list and pharmacy coverage.'
  },
  {
    user_id: 18392,
    reason: 'Cost Savings',
    description: 'Specialty oncology drug, large savings possible.',
    priority: 'Low',
    suggested_action:
      'Current: Revlimid 25 mg daily. Check formulary for lenalidomide generic. Coordinate with oncology team for substitution.'
  },
  {
    user_id: 26981,
    reason: 'Cost Savings',
    description: 'Multiple specialty drugs from same class.',
    priority: 'Low',
    suggested_action:
      'Current: Enbrel + Humira. Stop Enbrel, continue Humira only. Submit prior auth for biosimilar (Amjevita).'
  },
  {
    user_id: 21405,
    reason: 'Cost Savings',
    description: 'Branded antidepressant instead of generic.',
    priority: 'Low',
    suggested_action:
      'Current: Lexapro brand 10 mg. Switch to escitalopram generic 10 mg. Update pharmacy benefit plan.'
  },
  {
    user_id: 19547,
    reason: 'Cost Savings',
    description: 'Annual cost >$25K due to specialty RA therapy.',
    priority: 'Low',
    suggested_action:
      'Current: Xeljanz XR 11 mg daily. Switch to Rinvoq 15 mg daily (preferred formulary). Submit PA for cost savings.'
  },
  {
    user_id: 35628,
    reason: 'Cost Savings',
    description: 'High spend on combination therapy; single-agent cheaper.',
    priority: 'Low',
    suggested_action:
      'Current: Janumet 50/1000 mg bid. Switch to metformin 1000 mg bid + sitagliptin 100 mg daily generic. Educate on pill burden.'
  },
  {
    user_id: 11689,
    reason: 'Cost Savings',
    description: 'Uses injectable migraine therapy, biosimilar available.',
    priority: 'Low',
    suggested_action:
      'Current: Aimovig 140 mg monthly. Switch to fremanezumab (Ajovy) 225 mg monthly per formulary. Ensure coverage before switch.'
  }
]
